import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'
import store from '../store'

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

export const actions = {
  fetchConsentReports(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
    } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.getconsumerconsentreport}` +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  downloadTotalConsentReport(
    { commit, dispatch, getters },
    { startTime, endTime, timeZone, key, value, sortBy, sortDirection } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.downloadconsumerconsentreport}` +
      '?Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'ConsumerConsentReport.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ConsumerConsentReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchActivityDetailsReport(
    { commit, dispatch, getters },
    { activityID, timeZone }
  ) {
    var url = `${appConfig.apiEndPoint}${endpoint.reportApiPath.getconsumeractivityreportDetails}/${activityID}/${timeZone}`

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchActivityReport(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
    } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.getconsumeractivityreport}` +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  downloadconsumeractivityreport(
    { commit, dispatch, getters },
    { startTime, endTime, timeZone, key, value, sortBy, sortDirection } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.downloadconsumeractivityreport}` +
      '?Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(
            blob1,
            'ConsumerCreditActivityReport.csv'
          )
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ConsumerCreditActivityReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
}
